import olympiadLayout from "layouts/Olympiad.layout";
import { GetStaticProps } from "next/types";
import nextI18nextConfig from "next-i18next.config";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import CountriesScreen from "@cs/screens/olympiad/countries/CountriesScreen";

const Countries = () => <CountriesScreen />

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(
      locale ?? "en",
      ["common", "footer", "nav", "olympiad", "landing-page", "contact"],
      nextI18nextConfig
    ))
  }
});

Countries.getLayout = olympiadLayout

export default Countries;